import { NextRouter } from "next/router";

import { LoginFormFieldsTypes } from "../../common/contant";
import { LoginFormAuthResult } from "../loginFormAuth.types";
import {
    applyLoginSuccessSideEffects,
    LoginEventTracker,
    trackNewUserSignupStarted,
    trackRegisteredUserLogin
} from "./loginAuthAnalytics";
import { handlePostLoginNavigation } from "../handlePostLoginNavigation";

interface CreateRegisteredUserLoginHandlerParams {
    handleEventTracking: LoginEventTracker;
    globalData?: Record<string, unknown>;
    setGlobalData?: (data: Record<string, unknown>) => void;
    onComplete: (status: LoginFormAuthResult) => void | Promise<void>;
}

export function createRegisteredUserLoginHandler({
    handleEventTracking,
    globalData,
    setGlobalData,
    onComplete
}: CreateRegisteredUserLoginHandlerParams) {
    return async (status: LoginFormAuthResult) => {
        trackRegisteredUserLogin(handleEventTracking, status);
        applyLoginSuccessSideEffects({ status, globalData, setGlobalData });
        await onComplete(status);
    };
}

interface CreateFullPageRegisteredLoginHandlerParams {
    handleEventTracking: LoginEventTracker;
    globalData?: Record<string, unknown>;
    setGlobalData?: (data: Record<string, unknown>) => void;
    router: NextRouter;
    setShouldPreventLayoutSwitch?: (value: boolean) => void;
}

export function createFullPageRegisteredLoginHandler(params: CreateFullPageRegisteredLoginHandlerParams) {
    const { router, setShouldPreventLayoutSwitch, ...rest } = params;

    return createRegisteredUserLoginHandler({
        ...rest,
        onComplete: (status) =>
            handlePostLoginNavigation({
                router,
                status,
                setShouldPreventLayoutSwitch
            })
    });
}

interface CreateNewUserSignupHandlerParams {
    handleEventTracking: LoginEventTracker;
    phoneNum?: string | number;
    transitionToCompanyName: () => void;
}

export function createNewUserSignupHandler({
    handleEventTracking,
    phoneNum,
    transitionToCompanyName
}: CreateNewUserSignupHandlerParams) {
    return async (status: LoginFormAuthResult) => {
        trackNewUserSignupStarted(handleEventTracking, status, phoneNum);
        transitionToCompanyName();
    };
}

export type NewUserRegistrationSuccessHandler = (
    values: LoginFormFieldsTypes,
    result: LoginFormAuthResult
) => void | Promise<void>;
